import WebFont from 'webfontloader'

const options = {"google":{"families":["Outfit:400,500,600,700&display=swap"]}}

WebFont.load(options)
